import type { FC, ReactElement } from "react"

const Image: FC = (): ReactElement => (
    <svg width="51" height="50" viewBox="0 0 51 50" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M3.04717 44.7715H47.9528C49.3596 44.7715 50.5 45.9119 50.5 47.3187C50.5 48.7254 49.3596 49.8658 47.9528 49.8658H3.04717C1.64041 49.8658 0.5 48.7254 0.5 47.3187C0.5 45.9119 1.64041 44.7715 3.04717 44.7715Z"
            fill="#DA4200"
        />
        <path
            d="M22.6691 0.0718811C24.4727 0.456682 26.3372 0.456682 28.1408 0.0718811C29.7132 -0.263592 31.2944 0.602075 31.8589 2.10749L47.8578 44.7712H2.95215L18.951 2.10749C19.5156 0.602075 21.0967 -0.263592 22.6691 0.0718811Z"
            fill="#FE4D00"
        />
        <path d="M38.1724 18.9219H12.669L10.3105 25.1483H40.4992L38.1724 18.9219Z" fill="#FEA57F" />
        <mask
            id="mask0_19295_41612"
            // @ts-expect-error skip style check
            style={{ maskStyle: "alpha" }}
            maskUnits="userSpaceOnUse"
            x="10"
            y="18"
            width="31"
            height="8"
        >
            <path d="M38.1724 18.9219H12.669L10.3105 25.1483H40.4992L38.1724 18.9219Z" fill="#FEA57F" />
        </mask>
        <g mask="url(#mask0_19295_41612)">
            <path
                d="M10.877 23.0732L13.0776 21.1171C13.2752 20.9414 13.573 20.9414 13.7707 21.1171L15.6247 22.7651C15.8224 22.9408 16.1202 22.9408 16.3179 22.7651L18.1719 21.1171C18.3695 20.9414 18.6674 20.9414 18.865 21.1171L21.0656 23.0732"
                stroke="#FE4D00"
                strokeWidth="1.30415"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </g>
        <path d="M34.5568 9.2998H16.2549L13.9189 15.5262H36.9152L34.5568 9.2998Z" fill="#FEA57F" />
        <mask
            id="mask1_19295_41612"
            // @ts-expect-error skip style check
            style={{ maskStyle: "alpha" }}
            maskUnits="userSpaceOnUse"
            x="13"
            y="9"
            width="24"
            height="7"
        >
            <path d="M34.5568 9.2998H16.2549L13.9189 15.5262H36.9152L34.5568 9.2998Z" fill="#FEA57F" />
        </mask>
        <g mask="url(#mask1_19295_41612)">
            <path
                d="M26.1602 13.6396L28.3608 11.6835C28.5584 11.5078 28.8562 11.5078 29.0539 11.6835L30.9079 13.3315C31.1056 13.5072 31.4034 13.5072 31.6011 13.3315L33.4551 11.6835C33.6527 11.5078 33.9506 11.5078 34.1482 11.6835L36.3488 13.6396"
                stroke="#FE4D00"
                strokeWidth="1.30415"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </g>
        <path
            d="M17.1249 42.7391C20.7838 42.7391 23.7499 39.7728 23.7499 36.1137C23.7499 32.4546 20.7838 29.4883 17.1249 29.4883C13.4661 29.4883 10.5 32.4546 10.5 36.1137C10.5 39.7728 13.4661 42.7391 17.1249 42.7391Z"
            fill="#FFDCCE"
        />
        <path
            d="M33.9843 42.7391C37.6432 42.7391 40.6092 39.7728 40.6092 36.1137C40.6092 32.4546 37.6432 29.4883 33.9843 29.4883C30.3255 29.4883 27.3594 32.4546 27.3594 36.1137C27.3594 39.7728 30.3255 42.7391 33.9843 42.7391Z"
            fill="#FFDCCE"
        />
        <path
            opacity="0.9"
            d="M34.0441 39.4773C35.9017 39.4773 37.4075 37.9714 37.4075 36.1137C37.4075 34.256 35.9017 32.75 34.0441 32.75C32.1865 32.75 30.6807 34.256 30.6807 36.1137C30.6807 37.9714 32.1865 39.4773 34.0441 39.4773Z"
            fill="#071C41"
        />
        <path
            opacity="0.9"
            d="M17.1251 39.4773C18.9827 39.4773 20.4886 37.9714 20.4886 36.1137C20.4886 34.256 18.9827 32.75 17.1251 32.75C15.2676 32.75 13.7617 34.256 13.7617 36.1137C13.7617 37.9714 15.2676 39.4773 17.1251 39.4773Z"
            fill="#071C41"
        />
        <path
            d="M14.7809 35.1958C15.3438 35.1958 15.8002 34.7395 15.8002 34.1765C15.8002 33.6136 15.3438 33.1572 14.7809 33.1572C14.218 33.1572 13.7617 33.6136 13.7617 34.1765C13.7617 34.7395 14.218 35.1958 14.7809 35.1958Z"
            fill="#FFDCCE"
        />
        <path
            d="M31.6999 35.1958C32.2628 35.1958 32.7191 34.7395 32.7191 34.1765C32.7191 33.6136 32.2628 33.1572 31.6999 33.1572C31.137 33.1572 30.6807 33.6136 30.6807 34.1765C30.6807 34.7395 31.137 35.1958 31.6999 35.1958Z"
            fill="#FFDCCE"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M23.9424 40.898C23.9479 40.8893 23.9534 40.8805 23.959 40.8716C24.5306 39.9555 25.7366 39.6762 26.6527 40.2478C26.9143 40.4111 27.1336 40.6339 27.2927 40.898C27.5791 41.3737 28.028 41.8413 28.6392 42.3006C28.8012 42.4223 28.8338 42.6523 28.7121 42.8142C28.7007 42.8294 28.6881 42.8437 28.6744 42.857L28.1788 43.3384C27.6405 43.8612 27.1721 44.4514 26.7852 45.0943L26.1918 46.0803C26.0037 46.3928 25.5981 46.4936 25.2856 46.3056C25.1933 46.25 25.116 46.1727 25.0604 46.0803L24.467 45.0943C24.0801 44.4514 23.6116 43.8612 23.0734 43.3384L22.5897 42.8686C22.4444 42.7275 22.4411 42.4953 22.5822 42.35C22.5969 42.3349 22.6128 42.321 22.6299 42.3087C23.1442 41.9354 23.5817 41.4652 23.9424 40.898Z"
            fill="#FFDCCE"
        />
    </svg>
)

Image.displayName = "OwlDowntimeImage"

export { Image as OwlDowntimeImage }
